<li class="side-menu-navigation__item">
  <div
    [ngClass]="'navigation-item' + (isHighlighted && isColor ? ' navigation-item--selected' : '')"
    [style.backgroundColor]="isHighlighted && isColor && !isDarkTheme ? 'white' : isHighlighted && isColor && isDarkTheme ? '#435162' : 'transparent'">
    <div class="navigation-item__dimmer">
      <a class="navigation-item__link" mat-button [routerLink]="url" [disableRipple]="true" [attr.data-test]="dataTest">
        @if (icon) {
          <span [ngClass]="'navigation-item__icon icon-' + icon"></span>
        }
        @if (materialIcon) {
          <span class="navigation-item__icon material-icons">{{ materialIcon }}</span>
        }
        @if (translationKey === "inviteUser.title") {
          <span class="navigation-item__label_noTitlecase">{{ translationKey | translate }}</span>
        } @else {
          <span class="navigation-item__label">{{ translationKey | translate | titlecase }}</span>
        }
        @if (adminOnly) {
          <mat-icon class="admin-only-tag">font_download</mat-icon>
        }
        @if (isBetaItem) {
          <span class="beta navigation-item__label">BETA</span>
        }
        @if (isNew) {
          <span class="new-addon">NEW</span>
        }
        @if (showUpgradeTag) {
          <app-account-upgrade-tag></app-account-upgrade-tag>
        }
      </a>
    </div>
  </div>
</li>

@if (isSelected || (url === "/campaigns" && activeUrl === "/")) {
  <ul class="side-menu-sub-navigation">
    <ng-content select="navigation-sub-item"></ng-content>
  </ul>
}

@if (showCampaignCreateButton) {
  <button mat-stroked-button class="secondary-button transparent-button" (click)="routeToTemplatePage()" data-test="menu-campaigns-create">
    <span class="btn-label">
      <mat-icon>add_circle_outline</mat-icon>
      <span class="text-add">{{ "generic.create" | translate }}</span>
    </span>
  </button>
}
